import { render, staticRenderFns } from "./ItemBox.vue?vue&type=template&id=0b08d02a&scoped=true&"
import script from "./ItemBox.vue?vue&type=script&lang=js&"
export * from "./ItemBox.vue?vue&type=script&lang=js&"
import style0 from "./ItemBox.vue?vue&type=style&index=0&id=0b08d02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b08d02a",
  null
  
)

export default component.exports